import { useState } from 'react'

import { Box, Drawer } from '@mui/material'
import { Outlet } from 'react-router-dom'

import { BranchAccessGuard } from '../../routes/branchAccessGuard'

import { Header } from './Header'
import { Sidebar } from './Sidebar'

const drawerWidth = 240
const collapsedWidth = 80

function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const sidebarWidth = sidebarCollapsed ? collapsedWidth : drawerWidth

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Box
        component="nav"
        sx={{
          width: sidebarWidth,
          flexShrink: { sm: 0 },
          display: { xs: 'none', sm: 'block' },
          transition: 'width 200ms ease',
        }}
      >
        <Drawer
          variant="permanent"
          open
          sx={{
            '& .MuiDrawer-paper': {
              width: sidebarWidth,
              boxSizing: 'border-box',
              border: 'none !important',
              borderRight: '1px solid var(--sidebar-border) !important',
              bgcolor: '#08112b',
              color: '#f8fbff',
              overflowX: 'visible',
              overflowY: 'visible',
              transition: 'width 200ms ease',
              borderRadius: 0,
              boxShadow: 'none !important',
            },
          }}
        >
          <Sidebar collapsed={sidebarCollapsed} />
        </Drawer>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: `calc(100% - ${sidebarWidth}px)`,
        }}
      >
        <Header
          onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
          sidebarCollapsed={sidebarCollapsed}
        />
        <Box component="main" sx={{ flex: 1, p: { xs: 2, md: 3 }, overflow: 'auto' }}>
          <BranchAccessGuard>
            <Outlet />
          </BranchAccessGuard>
        </Box>
      </Box>
    </Box>
  )
}

const VerticalLayout = MainLayout
export { VerticalLayout }
export default MainLayout
